import { $ } from "@/common/Axios";

export default {
  /**
   * 活动参与管理
   */
  activityManage_reorderAdmin: {
    /*
     * 调整管理员顺序
     * activityName 活动名称 (string query required)
     * adminIds 管理员ID列表（期望顺序） (array query required)
     */
    put: (p, c) => $.put("/api/bms/activity/activityManage/reorderAdmin", p, c),
  },
  activityManage_contact: {
    /*
     * 标记已联系
     * id id (integer query required)
     * contactContent 联系内容 (string query required)
     */
    put: (p, c) => $.put("/api/bms/activity/activityManage/contact", p, c),
  },
  activityManage_assign: {
    /*
     * 手动改派负责人
     * id id (integer query required)
     * ownerId 负责人ID (integer query required)
     */
    put: (p, c) => $.put("/api/bms/activity/activityManage/assign", p, c),
  },
  activityManage_addAdmin: {
    /*
     * 添加管理员
     * activityName 活动名称 (string query required)
     * adminId 管理员ID (integer query required)
     * sort 排序位置（不传则加到末尾） (integer query )
     */
    post: (p, c) => $.post("/api/bms/activity/activityManage/addAdmin", p, c),
  },
  activityManage_list: {
    /*
     * 参与列表
     */
    get: (p, c) => $.get("/api/bms/activity/activityManage/list", p, c),
  },
  activityManage_listAdmin: {
    /*
     * 查询管理员列表（按分配顺序）
     * activityName 活动名称 (string query required)
     */
    get: (p, c) => $.get("/api/bms/activity/activityManage/listAdmin", p, c),
  },
  activityManage_currentPosition: {
    /*
     * 查看当前分配位置（下一个将被分配的管理员排第几位）
     * activityName 活动名称 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/activity/activityManage/currentPosition", p, c),
  },
  activityManage_removeAdmin: {
    /*
     * 移除管理员
     * activityName 活动名称 (string query required)
     * adminId 管理员ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/activity/activityManage/removeAdmin", p, c),
  },

  /**
   * 免试专升本线索统计配置
   */
  exemptionDegreeClueStatistics: {
    /*
     * 添加
     * item  ( query required)
     */
    post: (p, c) =>
      $.post("/api/bms/activity/exemptionDegreeClueStatistics", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/activity/exemptionDegreeClueStatistics", p, c),
  },
  exemptionDegreeClueStatistics_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/bms/activity/exemptionDegreeClueStatistics/upload", p, c),
  },
  exemptionDegreeClueStatistics_saveTokenConfig: {
    /*
     * 保存播报群token配置
     * content 内容： name, token (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/bms/activity/exemptionDegreeClueStatistics/saveTokenConfig",
        p,
        c
      ),
  },
  exemptionDegreeClueStatistics_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/activity/exemptionDegreeClueStatistics/list", p, c),
  },
  exemptionDegreeClueStatistics_getTokenConfig: {
    /*
     * 获取播报群token配置
     */
    get: (p, c) =>
      $.get(
        "/api/bms/activity/exemptionDegreeClueStatistics/getTokenConfig",
        p,
        c
      ),
  },
  exemptionDegreeClueStatistics_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/bms/activity/exemptionDegreeClueStatistics/export", p, c),
  },

  /**
   * 2026双十一活动
   */
  double11_uploadConfig: {
    /*
     * 导入战队配置（Excel：作战小组、招生老师、指标(万)）
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/bms/activity/double11/uploadConfig", p, c),
  },
  double11_setExtraGmv: {
    /*
     * 设置额外GMV（operateType：添加/修改/删除/清空；聚合只看作战小组，team 可为 总部其他）
     * extra  ( query required)
     */
    post: (p, c) => $.post("/api/bms/activity/double11/setExtraGmv", p, c),
  },
  double11_setConfig: {
    /*
     * 设置战队配置（operateType：添加/修改/删除/清空）
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/bms/activity/double11/setConfig", p, c),
  },
  double11_statisticsInfo: {
    /*
     * 双十一活动统计（作战小组 + 总部其他 + 全部）
     */
    get: (p, c) => $.get("/api/bms/activity/double11/statisticsInfo", p, c),
  },
  double11_listTeam: {
    /*
     * 获取可选作战小组（战队配置里的小组 + 总部其他）
     */
    get: (p, c) => $.get("/api/bms/activity/double11/listTeam", p, c),
  },
  double11_getExtraGmv: {
    /*
     * 获取额外GMV（手动调整，金额可为负）
     */
    get: (p, c) => $.get("/api/bms/activity/double11/getExtraGmv", p, c),
  },
  double11_getConfig: {
    /*
     * 获取战队配置（作战小组 + 成员 + 指标）
     */
    get: (p, c) => $.get("/api/bms/activity/double11/getConfig", p, c),
  },
  double11_exportStatisticsInfo: {
    /*
     * 双十一活动导出（订单明细，可按作战小组筛选）
     * team 作战小组名称（如 总部其他 或 全部）；不传=全部明细 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/activity/double11/exportStatisticsInfo", p, c),
  },
  double11_exportConfig: {
    /*
     * 导出战队配置（导出的文件可直接作导入模板）
     */
    get: (p, c) => $.get("/api/bms/activity/double11/exportConfig", p, c),
  },

  /**
   * 中军招生指标配置
   */
  armyEnrollTarget: {
    /*
     * 添加
     * target  ( query required)
     */
    post: (p, c) => $.post("/api/bms/activity/armyEnrollTarget", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/activity/armyEnrollTarget", p, c),
  },
  armyEnrollTarget_upload: {
    /*
     * 导入指标
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/bms/activity/armyEnrollTarget/upload", p, c),
  },
  armyEnrollTarget_saveCoefficient: {
    /*
     * 配置指标系数
     * content 月 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/activity/armyEnrollTarget/saveCoefficient", p, c),
  },
  armyEnrollTarget_listPage: {
    /*
     * 个人指标列表-基础平台-招生管理-中军招生指标
     */
    get: (p, c) => $.get("/api/bms/activity/armyEnrollTarget/listPage", p, c),
  },
  armyEnrollTarget_getStatisticsPageByMonth: {
    /*
     * 中军汇报数据
     * year 年 (integer query required)
     * month 月 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/activity/armyEnrollTarget/getStatisticsPageByMonth",
        p,
        c
      ),
  },
  armyEnrollTarget_getCoefficient: {
    /*
     * 获取配置的指标系数
     */
    get: (p, c) =>
      $.get("/api/bms/activity/armyEnrollTarget/getCoefficient", p, c),
  },
  armyEnrollTarget_export: {
    /*
     * 导出-基础平台-招生管理-中军招生指标
     */
    get: (p, c) => $.get("/api/bms/activity/armyEnrollTarget/export", p, c),
  },
  armyEnrollTarget_downloadMould: {
    /*
     * 下载指标导入模版
     */
    get: (p, c) =>
      $.get("/api/bms/activity/armyEnrollTarget/downloadMould", p, c),
  },

  /**
   * 活动参与
   */
  activity_sendVerify: {
    /*
     * 发送短信验证码
     * activityName 活动名称 (string query required)
     * phone 手机号 (string query required)
     */
    post: (p, c) => $.post("/api/bms/activity/activity/sendVerify", p, c),
  },
  activity_participate: {
    /*
     * 验证并参与活动
     * activityName 活动名称 (string query required)
     * phone 手机号 (string query required)
     * verifyCode 验证码 (string query required)
     */
    post: (p, c) => $.post("/api/bms/activity/activity/participate", p, c),
  },
  activity_status: {
    /*
     * 查询参与状态
     * activityName 活动名称 (string query required)
     * phone 手机号 (string query required)
     */
    get: (p, c) => $.get("/api/bms/activity/activity/status", p, c),
  },
};
